import { render, staticRenderFns } from "./properties-wrapper.vue?vue&type=template&id=162ce63a&scoped=true&"
import script from "./properties-wrapper.vue?vue&type=script&lang=ts&"
export * from "./properties-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./properties-wrapper.vue?vue&type=style&index=0&id=162ce63a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162ce63a",
  null
  
)

export default component.exports